"use client";

import { GeoStatus } from "@/components/ui/GeoStatus";
import { GeoSelectorTrigger } from "@/features/navigation/GeoSelector";

export const GeoSelectorWrapper = () => {
  return (
    <GeoSelectorTrigger asChild>
      <GeoStatus />
    </GeoSelectorTrigger>
  );
};
